import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LiquidationBondsMain from "./LiquidationBondsMain";
import LiquidationMldMain from "./LiquidationMldMain";
import { getAllBonds, getRedeemptionAmount } from "../services/waitlist-service";
import { toast } from "react-toastify";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import ReactGA from "react-ga4";
import { utils } from "../../core/helpers/utils";

export default function LiquidationMain(props) {
    
    const [bondDetails, setBondDetails] = useState();
    const[order_Id, setOrder_Id] = useState('');
    const [liquidationDetails, setLiquidationDetails] = useState();
    const [loader, setLoader] = useState(true);
    const [redemptionSuccess, setRedemptionSuccess] = useState(false);



    const { productType, product } = useParams()

    
    useEffect(()=>{
        ReactGA.send({hitType: "pageview", page_location: "redeem/liquidation"})
        { process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent(window.location.hash, "liquidation");
        }
        getAllBonds().then((result) => {
            const response = utils.parsePayload(result);

            if (!response || !response.success) {
              toast.error(response.message || "Error: Unable to fetch bonds details");
              return;
            }
            ([...response.data]).filter((item) => item.product=== product && setBondDetails(item))
          });
    },[])

    useEffect(()=>{
        if(bondDetails){
        getRedeemptionAmount(bondDetails.ISIN, { "X-product": `orobonds:${bondDetails.product}` }).then(
            (result) => {
                const res = utils.parsePayload(result);
                if (res) {
                    setLiquidationDetails(res.data)
                    setLoader(false)
                }
                if(!res.success){
                    toast.error("Something went wrong")
                    setRedemptionSuccess(!redemptionSuccess)
                }
            },
            (err) => {
                toast.error("Asset Details (Error):", err);
            }
        );
    }
    },[bondDetails])

    switch (productType) {
        case 'bonds':
            return <LiquidationBondsMain
                phone={props?.phone}
                userEmail={props?.userEmail}
                bondDetails={bondDetails}
                liquidationDetails={liquidationDetails}
                loader={loader}
                redemptionSuccess={redemptionSuccess}
                 />;
        case 'mld':
            return <LiquidationMldMain
                phone={props?.phone}
                userEmail={props?.userEmail}
                liquidationDetails={liquidationDetails}
                loader={loader}
                redemptionSuccess={redemptionSuccess}
                bondDetails={bondDetails} />
        default:
            return null
    }
}
